
export const productsList = [
    {
        name: "VCT32, VCT64",
        avg_xray_gen_of_events: 1.3,
        avg_downtime_for_xray_gen: 68.9,
        avg_limited_use: 76.5,
        avg_labor_hours: 12.39,
        xray_tube_failure_avg_donwtime_in_h: 56,
        avg_labor: 5,
        perf: 0.87,
    },
    {
        name: "Optima 540, Optima 6xx, Rev Evo, Maxima,Ascend",
        avg_xray_gen_of_events: 0.71,
        avg_downtime_for_xray_gen: 56.9,
        avg_limited_use: 74,
        avg_labor_hours: 15.2,
        xray_tube_failure_avg_donwtime_in_h: 53,
        avg_labor: 5,
        perf: 0.87,
    },
    {
        name: "Rev HD, 750 HD , Frontier",
        avg_xray_gen_of_events: 1.34,
        avg_downtime_for_xray_gen: 64,
        avg_limited_use: 86,
        avg_labor_hours: 24.3,
        xray_tube_failure_avg_donwtime_in_h: 65,
        avg_labor: 5,
        perf: 0.87,
    },
    {
        name: "CT Rev APEX",
        avg_xray_gen_of_events: 0.75,
        avg_downtime_for_xray_gen: 42.4,
        avg_limited_use: 0,
        avg_labor_hours: 19.86,
        xray_tube_failure_avg_donwtime_in_h: 78,
        avg_labor: 16,
        perf: 0.72,
    },
] as const;